export enum UserRole {
  ADMIN = 'ADMIN',
  READ_ONLY = 'READ_ONLY',
  FACILITY_MANAGER = 'FACILITY_MANAGER',
  ACCOUNTING = 'ACCOUNTING',
  TECHNICIAN = 'TECHNICIAN',
}

export interface User {
  name: string;
  email: string;
  phone: string;
  userRole: UserRole;
}

export interface Invite {
  inviteId: string;
  email: string;
  companyId: string;
  status: string;
  dateRequested: Date;
  timeSinceLastInviteSecond: number;
}
